import React from "react";
import { graphql, compose } from "lib/apolloClient";
import { connect } from "react-redux";
import _ from "lodash";

// components
import Loading from "UIComponents/Loading";
import GradeScaleDatagrid from "Administrator/commonComponents/GradingSetupV2/components/GradeScaleDatagrid";

// design system
import { DSProvider, Modal } from "@toddle-edu/ds-web";

// modules
import { getGradeScaleDetailsQuery } from "../../modules/AssessmentGradeScaleToolQueries";
import { getSelectedCurriculumId } from "modules/CommonSelectors";

// scss
import classes from "./GradeScaleDetailModal.scss";

const styles = {
  header: {
    padding: "16px 24px 8px",
  },
  body: {
    padding: "8px 24px 16px",
    minHeight: "320px",
    maxHeight: "600px",
  },
  containerStyle: {
    overflow: "auto",
  },
};

const columnWidthMap = {
  abbreviation: 80,
  label: 200,
  description: 240,
  color: 80,
  Cutoff: 130,
  GradeValue: 130,
};

const GradeScaleDetailModal = props => {
  const { onClose, gradeScaleEntityDetails, isData, isLoading } = props;

  const { gradeScale, gradeScaleValues, gradeValueCalculateTypeDetail } =
    gradeScaleEntityDetails || {};

  const { displayName, type: gradeScaleType, gradingType } = gradeScale || {};

  const gradeValueMethod = _.get(
    gradeValueCalculateTypeDetail,
    "[0].gradeValueCalculateType"
  );

  const renderBody = () => {
    if (!isData && isLoading) return <Loading />;

    return (
      <div className={classes.gradeScaleContainer}>
        <GradeScaleDatagrid
          gradeScaleType={gradeScaleType}
          gradeScaleValuesData={gradeScaleValues}
          gradeValueMethod={gradeValueMethod}
          gradeType={gradingType}
          isEditMode={false}
          showActions={false}
          isMasteryLevelEnabled={false}
          isUseForCreditGPACalculation={false}
          columnWidthMap={columnWidthMap}
          containerStyle={styles.containerStyle}
        />
      </div>
    );
  };

  return (
    <DSProvider dsVersion="2.0">
      <Modal
        isOpen={true}
        closeOnOutSideClick={true}
        width="880px"
        height="fit-content"
        onClose={onClose}
      >
        <Modal.Header title={displayName} isClosable style={styles.header} />
        <Modal.Body isScrollable={false} style={styles.body}>
          {renderBody()}
        </Modal.Body>
      </Modal>
    </DSProvider>
  );
};

const mapStateToProps = state => {
  const curriculumProgramId = getSelectedCurriculumId(state);
  return { curriculumProgramId };
};

export default compose(
  connect(mapStateToProps, null),
  graphql(getGradeScaleDetailsQuery, {
    name: "getGradeScaleDetails",
    skip: ({ toolId }) => !toolId,
    options: ({ toolId }) => {
      return {
        fetchPolicy: "cache-and-network",
        variables: { id: toolId },
      };
    },
    props({ getGradeScaleDetails: { node, networkStatus } }) {
      return {
        gradeScaleEntityDetails: node,
        isData: !_.isEmpty(node),
        isLoading: _.includes([1, 2], networkStatus),
      };
    },
  })
)(GradeScaleDetailModal);
